'use strict';

const { getConfig } = require('../common/jsConfig');

module.exports = function (len = 5) {
    function productTilePlaceholder() {
        const isProductTileCallToActionButton = getConfig('isProductTileCallToActionButton');

        return `
            <div class="product-tile product-tile-placeholder placeholder-glow" aria-hidden="true">
                <div class="product-tile-row">
                    <div class="product-tile-col pos-0">
                        <div class="image-container">
                            <div class="ratio ratio-1x1">
                                <div class="placeholder"></div>
                            </div>
                        </div>
                    </div>
                    <div class="product-tile-col pos-1 d-flex flex-column gap-2">
                        <div class="col-11 placeholder rounded"></div>
                        <div class="col-10 placeholder rounded"></div>
                        <div class="col-4 placeholder rounded"></div>
                        
                    </div>
                    <div class="product-tile-col pos-2 d-flex flex-column gap-2 pt-2">
                        <div class="col-4 placeholder rounded"></div>
                        <div class="col-8 placeholder rounded"></div>
                        <div class="col-6 placeholder rounded"></div>
                        ${isProductTileCallToActionButton ? '<div class="col-12 py-6 px-9 mt-2 placeholder rounded"></div>' : ''}
                    </div>
                </div>
            </div>
        `;
    }

    return Array(len).fill('').map(() => productTilePlaceholder()).join('');
};
